/* tp-reels (26.10.2026): "Descopera" - viewer in stil Reels/Stories pentru produse.
   Feed vertical (un produs pe ecran), tab-uri pe categorii cu glisare orizontala, galerie automata cu bare de progres,
   dublu-tap = favorite, mareste/alege marimea si adauga in cos direct din feed (cosul existent se deschide deasupra).
   Date: /collections/<handle>?view=tp-reel&page=N (templates/collection.tp-reel.liquid). Nimic nu porneste pana nu deschide clientul viewerul.
   Opriri: ?tprl=0 | ?tps=0 | localStorage tprl_off=1. */
(function () {
  'use strict';
  if (window.__tprl) return;
  var q = location.search;
  if (/[?&](tps|tprl)=0(&|$)/.test(q)) { document.documentElement.classList.add('tprl-off'); return; }
  try { if (localStorage.getItem('tprl_off') === '1') { document.documentElement.classList.add('tprl-off'); return; } } catch (e) {}
  if (typeof HTMLDialogElement === 'undefined') { document.documentElement.classList.add('tprl-off'); return; }
  window.__tprl = 1;

  var doc = document, root = doc.documentElement;
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var fine = !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function el(tag, cls, html) { var n = doc.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function safe(f) { try { return f(); } catch (e) { return undefined; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mix(a, b, t) { return [Math.round(a[0] + (b[0] - a[0]) * t), Math.round(a[1] + (b[1] - a[1]) * t), Math.round(a[2] + (b[2] - a[2]) * t)]; }
  function rgb(c) { return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')'; }
  var NF = null;
  function money(c) { if (!NF) { try { NF = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); } catch (e) { NF = { format: function (v) { return v.toFixed(2).replace('.', ','); } }; } } return NF.format(c / 100) + ' lei'; }

  /* ordinea trebuie sa fie aceeasi cu snippets/tp-reels-rings.liquid */
  var STATIC = [
    { l: 'Noutăți', u: '/collections/all', q: 'sort_by=created-descending&filter.v.availability=1' },
    { l: 'Ghete damă', u: '/collections/ghete-dama' },
    { l: 'Sport damă', u: '/collections/pantofi-sport-dama' },
    { l: 'Sport bărbați', u: '/collections/pantofi-sport-barbati' },
    { l: 'Casual damă', u: '/collections/pantofi-casual-dama' },
    { l: 'Eleganți damă', u: '/collections/pantofi-eleganti-dama' },
    { l: 'Ghete bărbați', u: '/collections/ghete-barba%C8%9Bi' },
    { l: 'Skechers', u: '/collections/skechers' },
    { l: 'Tamaris', u: '/collections/tamaris' },
    { l: 'Anekke', u: '/collections/anekke' },
    { l: 'Copii', u: '/collections/pantofi-sport-copii' }
  ];
  STATIC.forEach(function (t, k) { t.k = k; t.id = 's' + k; t.href = t.u; });
  var TABS = STATIC;

  var ICON = {
    x: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    heart: '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>',
    share: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 15V3M7.5 7.5 12 3l4.5 4.5M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    up: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 14l6-6 6 6"/></svg>',
    down: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 10l6 6 6-6"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>',
    snd: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M4 9.5v5h3.5l4.5 4v-13l-4.5 4z"/><path class="w" d="M15.5 9a4 4 0 0 1 0 6M18 6.5a8 8 0 0 1 0 11"/><path class="x" d="M16 9.5l5 5M21 9.5l-5 5"/></svg>'
  };

  /* ---------------------------------------------------------------- favorite (aceeasi stocare ca tp-wow) */
  var FKEY = 'tp_favs_v1';
  function favRead() { try { var a = JSON.parse(localStorage.getItem(FKEY)); return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }) : []; } catch (e) { return []; } }
  var favCache = null;
  function favHas(h) { if (!favCache) { favCache = {}; favRead().forEach(function (x) { favCache[x.h] = 1; }); } return !!favCache[h]; }
  function favToggle(h) {
    var a = favRead(), i = -1, k;
    for (k = 0; k < a.length; k++) if (a[k].h === h) { i = k; break; }
    if (i >= 0) a.splice(i, 1); else a.unshift({ h: h, t: Date.now() });
    try { localStorage.setItem(FKEY, JSON.stringify(a)); } catch (e) {}
    favCache = null;
    safe(function () { window.dispatchEvent(new StorageEvent('storage', { key: FKEY })); });   /* tp-wow isi sincronizeaza numaratorul din antet */
    return i < 0;
  }

  /* ---------------------------------------------------------------- "vazut" pe inele */
  var SKEY = 'tprl_seen';
  function seenRead() { try { return JSON.parse(localStorage.getItem(SKEY)) || {}; } catch (e) { return {}; } }
  function markSeen(i) {
    var s = seenRead(); s[i] = Date.now();
    try { localStorage.setItem(SKEY, JSON.stringify(s)); } catch (e) {}
    paintRings();
  }
  function paintRings() {
    var s = seenRead(), day = 20 * 3600 * 1000, now = Date.now();
    $$('[data-tprl-ring]').forEach(function (r) { r.classList.toggle('is-seen', !!s[r.getAttribute('data-i')] && now - s[r.getAttribute('data-i')] < day); });
  }

  /* ---------------------------------------------------------------- date */
  var state = [];   /* per tab: {items, page, more, loading, pane, feed, seen:{} } */
  function feedUrl(i, page) {
    var t = TABS[i], qs = t.q || 'filter.v.availability=1';
    return t.u + '?' + qs + '&view=tp-reel&page=' + page;
  }
  function fromProductJs(p) {
    if (!p || !p.variants || !p.variants.some(function (v) { return v.available; })) return null;
    function w(u) { u = String(u); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=900'; }
    var imgs = (p.images || []).slice(0, 4).map(function (u) { return w(typeof u === 'string' ? u : (u && u.src) || ''); });
    return { h: p.handle, t: p.title, v: p.vendor, p: p.price, c: p.compare_at_price > p.price ? p.compare_at_price : 0, i: imgs,
      o: (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }),
      vs: p.variants.map(function (v) { return [v.id, v.available ? 1 : 0, v.option1, v.option2, v.option3]; }) };
  }
  function loadLocal(i) {
    var s = state[i], t = TABS[i], PER = 8;
    s.loading = true;
    var hs = t.list.slice(s.page * PER, (s.page + 1) * PER);
    return Promise.all(hs.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (arr) {
      s.page++; s.more = s.page * PER < t.list.length; s.loading = false; s.fails = 0;
      var fresh = arr.map(fromProductJs).filter(function (it) { if (!it || s.seen[it.h]) return false; s.seen[it.h] = 1; return true; });
      s.items = s.items.concat(fresh);
      renderItems(i, fresh);
      if (!fresh.length && s.more) return loadLocal(i);
    }).catch(function () { s.loading = false; s.fails = (s.fails || 0) + 1; renderError(i); });
  }
  function loadPage(i) {
    var s = state[i];
    if (!s || s.loading || !s.more) return Promise.resolve();
    if (TABS[i].src === 'local') return loadLocal(i);
    s.loading = true;
    var url = feedUrl(i, s.page + 1), P = s.page === 0 ? fetchFeed(url) : fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); }).then(JSON.parse);
    return P
      .then(function (d) {
        s.page++; s.more = !!d.more; s.loading = false; s.fails = 0;
        var fresh = (d.items || []).filter(function (it) { if (s.seen[it.h]) return false; s.seen[it.h] = 1; return true; });
        s.items = s.items.concat(fresh);
        renderItems(i, fresh);
        if (!fresh.length && s.more) return loadPage(i);
      })
      .catch(function () { s.loading = false; s.fails = (s.fails || 0) + 1; renderError(i); });
  }
  var pre = {};   /* url feed -> Promise<json|null> */
  function fetchFeed(url) {
    if (pre[url] && Date.now() - pre[url].t < 90000) return pre[url].p;   /* cache scurt: stocul se schimba */
    var pr = (fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        (d.items || []).slice(0, 3).forEach(function (it) { if (it.i && it.i[0]) { var im = new Image(); im.decoding = 'async'; im.src = abs(it.i[0]); } });   /* poza e deja in cache cand se deschide viewerul */
        return d;
      })
      .catch(function (e) { delete pre[url]; throw e; }));
    pre[url] = { t: Date.now(), p: pr };
    return pr;
  }
  function prefetch(sel) {   /* la hover/atingere pe inel: aduce prima pagina + primele poze */
    var i = typeof sel === 'number' ? sel : STATIC.length;
    var t = STATIC[i]; if (!t) return;
    var q = t.q || 'filter.v.availability=1';
    safe(function () { fetchFeed(t.u + '?' + q + '&view=tp-reel&page=1').catch(function () {}); });
  }

  /* ---------------------------------------------------------------- culoare ambientala per produs */
  var DEFAULT_PAIR = [[255, 226, 208], [255, 214, 228]];
  var colorCache = {};
  function tinyUrl(u) { return String(u).replace(/width=\d+/, 'width=36'); }
  function ambient(it) {
    if (colorCache[it.h]) return Promise.resolve(colorCache[it.h]);
    return new Promise(function (res) {
      var im = new Image();
      im.onload = function () {
        var out = DEFAULT_PAIR;
        safe(function () {
          var c = doc.createElement('canvas'); c.width = c.height = 18;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0, 18, 18);
          var d = x.getImageData(0, 0, 18, 18).data, r = 0, g = 0, b = 0, w = 0, n = 0;
          for (var k = 0; k < d.length; k += 4) {
            if (d[k + 3] < 128) continue;
            var R = d[k], G = d[k + 1], B = d[k + 2], mx = Math.max(R, G, B), mn = Math.min(R, G, B);
            if (mn > 236) continue;                         /* fundal alb */
            var sat = mx ? (mx - mn) / mx : 0, wt = 1 + sat * 3;
            r += R * wt; g += G * wt; b += B * wt; w += wt; n++;
          }
          if (n >= 6) {
            var avg = [r / w, g / w, b / w];
            avg = mix(avg, [255, 110, 150], .22);          /* trage spre roz-ul magazinului ca sa nu iasa murdar */
            out = [mix(avg, [255, 255, 255], .56), mix(mix(avg, [255, 150, 90], .35), [255, 255, 255], .48)];
          }
        });
        colorCache[it.h] = out; res(out);
      };
      im.onerror = function () { res(DEFAULT_PAIR); };
      im.src = tinyUrl(abs(it.i[0]));
    });
  }
  function abs(u) { return String(u).indexOf('//') === 0 ? location.protocol + u : u; }

  /* ---------------------------------------------------------------- variante */
  function parseItem(it) {
    var o = it.o || [], si = -1, ci = -1;
    o.forEach(function (n, k) { if (/m[aă]rime|size/i.test(n)) si = k; else if (/color|culoare/i.test(n)) ci = k; });
    if (si < 0 && ci < 0 && o.length === 1 && o[0] !== 'Title') si = 0;
    var vs = (it.vs || []).map(function (v) { return { id: v[0], a: !!v[1], o: [v[2], v[3], v[4]] }; });
    var colors = [], sizes = [];
    vs.forEach(function (v) {
      var c = ci >= 0 ? v.o[ci] : null, s = si >= 0 ? v.o[si] : null;
      if (c != null && colors.indexOf(c) < 0) colors.push(c);
      if (s != null && sizes.indexOf(s) < 0) sizes.push(s);
    });
    sizes.sort(function (a, b) { var x = parseFloat(String(a).replace(',', '.')), y = parseFloat(String(b).replace(',', '.')); return (isNaN(x) || isNaN(y)) ? 0 : x - y; });
    var selColor = null;
    for (var k = 0; k < colors.length && selColor == null; k++) if (vs.some(function (v) { return v.a && v.o[ci] === colors[k]; })) selColor = colors[k];
    if (selColor == null && colors.length) selColor = colors[0];
    return { si: si, ci: ci, vs: vs, colors: colors, sizes: sizes, selColor: selColor, selSize: null };
  }
  function variantFor(m) {
    var out = null;
    m.vs.forEach(function (v) {
      if (out && out.a) return;
      if (m.ci >= 0 && v.o[m.ci] !== m.selColor) return;
      if (m.si >= 0 && v.o[m.si] !== m.selSize) return;
      if (!out || (!out.a && v.a)) out = v;
    });
    return out;
  }
  function sizeAvail(m, s) {
    return m.vs.some(function (v) { return v.a && (m.ci < 0 || v.o[m.ci] === m.selColor) && v.o[m.si] === s; });
  }

  /* ---------------------------------------------------------------- DOM viewer */
  var dlg, panes, tabsEl, indEl, closeBtn, toastEl, hintEl, navUp, navDown, srEl;
  var cur = 0, built = false, opened = false, pushed = false, originEl = null, lastFocus = null, scrollY0 = 0, lastY = window.pageYOffset || 0;
  window.addEventListener('scroll', function () { if (!opened) lastY = window.pageYOffset || 0; }, { passive: true });
  var tabRects = [];

  function build() {
    if (built) return;
    built = true;
    dlg = el('dialog', 'tprl');
    dlg.setAttribute('aria-label', 'Descoperă produse');
    dlg.innerHTML =
      '<div class="tprl-bg" aria-hidden="true"><i class="is-on"></i><i></i></div>' +
      '<div class="tprl-shell">' +
        '<div class="tprl-top"><button type="button" class="tprl-x" aria-label="Închide">' + ICON.x + '</button>' +
          '<div class="tprl-tabs" role="tablist" aria-label="Categorii"><i class="tprl-ind" aria-hidden="true"></i></div>' +
          (AC ? '<button type="button" class="tprl-snd is-off" aria-pressed="false" aria-label="Pornește muzica">' + ICON.snd + '</button>' : '') + '</div>' +
        '<div class="tprl-panes"></div>' +
        '<div class="tprl-hint" aria-hidden="true"><span>' + ICON.up + '</span>' + (fine ? 'Derulează pentru următorul' : 'Glisează pentru următorul') + '</div>' +
        '<div class="tprl-toast" role="status" aria-live="polite"></div>' +
        '<div class="tprl-sr" aria-live="polite" aria-atomic="true"></div>' +
      '</div>' +
      '<div class="tprl-nav" aria-hidden="false"><button type="button" class="tprl-nav-up" aria-label="Produsul anterior">' + ICON.up + '</button><button type="button" class="tprl-nav-down" aria-label="Produsul următor">' + ICON.down + '</button></div>';
    doc.body.appendChild(dlg);
    panes = $('.tprl-panes', dlg); tabsEl = $('.tprl-tabs', dlg); indEl = $('.tprl-ind', dlg);
    closeBtn = $('.tprl-x', dlg); toastEl = $('.tprl-toast', dlg); hintEl = $('.tprl-hint', dlg); srEl = $('.tprl-sr', dlg);
    navUp = $('.tprl-nav-up', dlg); navDown = $('.tprl-nav-down', dlg);
    sndBtn = $('.tprl-snd', dlg); if (sndBtn) sndBtn.addEventListener('click', sndToggle);

    TABS.forEach(function (t, i) {
      var b = el('button', 'tprl-tab', esc(t.l)); b.type = 'button'; b.setAttribute('role', 'tab'); b.dataset.i = String(i);
      tabsEl.insertBefore(b, indEl);
      var pane = el('div', 'tprl-pane'); pane.dataset.i = String(i);
      pane.setAttribute('role', 'tabpanel'); pane.setAttribute('aria-label', t.l);
      var feed = pane;
      panes.appendChild(pane);
      state[i] = { items: [], page: 0, more: true, loading: false, pane: pane, feed: feed, seen: {}, active: null, fails: 0 };
      pane.appendChild(skeleton());
      watchPane(i);
    });

    closeBtn.addEventListener('click', function () { closeViewer(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeViewer(); });
    tabsEl.addEventListener('click', function (e) {
      var b = e.target.closest('.tprl-tab'); if (!b) return;
      goTab(Number(b.dataset.i), true);
    });
    navUp.addEventListener('click', function () { stepSlide(-1); });
    navDown.addEventListener('click', function () { stepSlide(1); });
    panes.addEventListener('scroll', onPanesScroll, { passive: true });
    panes.addEventListener('pointerdown', function () { pressed = true; }, { passive: true });
    ['pointerup', 'pointercancel'].forEach(function (t) { window.addEventListener(t, function () { if (pressed) { pressed = false; clearTimeout(settleT); settleT = setTimeout(settlePanes, 260); } }, { passive: true }); });
    state.forEach(function (st) { var pn = st.pane, tt = 0; pn.addEventListener('scroll', function () { clearTimeout(tt); tt = setTimeout(function () { settlePane(pn); }, 220); }, { passive: true }); });
    dlg.addEventListener('keydown', onKey);
    dlg.addEventListener('pointerdown', function () { if (!hintEl.classList.contains('is-gone')) setTimeout(hideHint, 400); }, { passive: true });
    dlg.addEventListener('wheel', onWheel, { passive: false });
    dlg.addEventListener('click', tutOnClick, true);
    dlg.addEventListener('scroll', tutOnScroll, true);
    ['pointerdown', 'wheel', 'keydown'].forEach(function (t) { dlg.addEventListener(t, function () { if (tutEl) tutTouched = true; }, { passive: true, capture: true }); });
  }
  window.addEventListener('resize', function () { if (opened && panes) { measureTabs(); panes.scrollTo({ left: cur * panes.clientWidth, behavior: 'auto' }); } });
  doc.addEventListener('visibilitychange', function () { if (opened) refreshActive(); });
  doc.addEventListener('tp:cart-updated', function () { if (dlg) onCartUpdated(); });
  window.addEventListener('pageshow', function () { $$('.tprl-photo img').forEach(function (i) { i.style.viewTransitionName = ''; }); });

  function tabsKey(list) { return list.map(function (t) { return (t.id || '') + ':' + (t.u || '') + '?' + (t.q || '') + (t.list ? '#' + t.list.join(',') : ''); }).join('|'); }
  /* feeduri personale: din ce are clientul pe dispozitiv (favorite, vazute recent) */
  function rvRead() { try { var a = JSON.parse(localStorage.getItem('tp_rv_v1')); return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }) : []; } catch (e) { return []; } }
  function personalTabs() {
    var out = [], f = favRead(), r = rvRead();
    if (f.length) out.push({ id: 'fav', l: 'Favorite', src: 'local', list: f.map(function (x) { return x.h; }).slice(0, 40) });
    if (r.length) out.push({ id: 'rv', l: 'Văzute', src: 'local', list: r.map(function (x) { return x.h; }).slice(0, 14) });
    return out;
  }
  function teardown() {
    if (!built) return;
    tutArm = false; tutEnd(false); sndStop(true); sndBtn = null;
    try { if (dlg.open) dlg.close(); } catch (e) {}
    observers.forEach(function (o) { if (o) o.disconnect(); }); observers = [];
    dlg.remove(); dlg = panes = tabsEl = indEl = closeBtn = toastEl = hintEl = navUp = navDown = srEl = null;
    state = []; built = false; opened = false; closing = false; pushed = false; ambKey = '';
    window.removeEventListener('popstate', onPop);
    showBg();
  }
  /* tab propriu = colectia curenta cu filtrele si ordonarea alese de client */
  function customTab(title) {
    var sp = new URLSearchParams(location.search);
    ['page', 'view', 'section_id', 'sections', 'tps', 'tprl', 'tpx'].forEach(function (k) { sp.delete(k); });
    var base = sp.toString(), filtered = false;
    sp.forEach(function (v, k) { if (/^filter\./.test(k) && k !== 'filter.v.availability') filtered = true; });
    var sort = sp.get('sort_by'), plainSort = !sort || sort === 'created-descending' || sort === 'manual';   /* ordonarea implicita a site-ului nu conteaza */
    var qs = base;
    if (!sp.has('filter.v.availability')) qs += (qs ? '&' : '') + 'filter.v.availability=1';
    var path = location.pathname.replace(/\/$/, '');
    for (var i = 0; i < STATIC.length; i++) if (STATIC[i].u === path && !filtered && plainSort) return null;
    var label = String(title || doc.title || 'Colecția').replace(/^Colec[țt]ie:\s*/i, '').replace(/\s*[|–-]\s*Total.*$/i, '').trim();
    if (label.length > 22) label = label.slice(0, 21) + '…';
    return { id: 'c', l: label + (filtered ? ' · filtrat' : ''), u: path, q: qs, custom: true, href: location.pathname + (base ? '?' + base : '') };
  }
  function staticIndexFor(path) {
    path = path.replace(/\/$/, '');
    for (var i = 0; i < STATIC.length; i++) if (STATIC[i].u === path) return i;
    return 0;
  }

  function skeleton() { return el('article', 'tprl-slide tprl-skel', '<div class="tprl-card"></div><div class="tprl-buy"><i></i><i></i></div>'); }

  /* ---------------------------------------------------------------- tab-uri */
  function measureTabs() {
    tabRects = $$('.tprl-tab', tabsEl).map(function (b) { return { l: b.offsetLeft, w: b.offsetWidth }; });
  }
  function paintIndicator(p) {
    if (!tabRects.length) return;
    var i = Math.max(0, Math.min(tabRects.length - 1, Math.floor(p))), t = p - i, a = tabRects[i], b = tabRects[Math.min(i + 1, tabRects.length - 1)];
    var l = a.l + (b.l - a.l) * t, w = a.w + (b.w - a.w) * t;
    indEl.style.transform = 'translate3d(' + (l + 12) + 'px,0,0)';
    indEl.style.width = Math.max(8, w - 24) + 'px';
  }
  function centerTab(i) {
    var r = tabRects[i]; if (!r) return;
    var left = r.l + r.w / 2 - tabsEl.clientWidth / 2;
    tabsEl.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
  }
  var rafScroll = 0, settleT = 0, pressed = false;
  function settlePanes() {
    if (!opened || !panes || pressed) return;
    var w = panes.clientWidth || 1, target = Math.round(panes.scrollLeft / w) * w;
    if (Math.abs(panes.scrollLeft - target) > 1.5) panes.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
  }
  function settlePane(pane) {
    if (!opened || pressed) return;
    var h = pane.clientHeight || 1, target = Math.round(pane.scrollTop / h) * h;
    if (Math.abs(pane.scrollTop - target) > 1.5 && target <= pane.scrollHeight - h + 1) pane.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
  }
  function onPanesScroll() {
    clearTimeout(settleT); settleT = setTimeout(settlePanes, 200);
    if (rafScroll) return;
    rafScroll = requestAnimationFrame(function () {
      rafScroll = 0;
      var w = panes.clientWidth || 1, p = panes.scrollLeft / w;
      paintIndicator(p);
      var n = Math.max(0, Math.min(TABS.length - 1, Math.round(p)));
      if (n !== cur) setCurrent(n);
    });
  }
  function setCurrent(n) {
    cur = n;
    $$('.tprl-tab', tabsEl).forEach(function (b, i) { var on = i === n; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    centerTab(n);
    ensure(n); ensure(n + 1); ensure(n - 1);
    refreshActive();
    if (TABS[n] && TABS[n].k != null) markSeen(TABS[n].k);
  }
  function goTab(i, smooth) {
    i = Math.max(0, Math.min(TABS.length - 1, i));
    var left = i * panes.clientWidth;
    if (smooth && !reduce) {
      /* cat dureaza derularea lina, scot snap-ul (altfel se opreste la jumatate intre taburi), apoi il pun la loc */
      panes.style.scrollSnapType = 'none';
      panes.scrollTo({ left: left, behavior: 'smooth' });
      clearTimeout(goTab._t);
      goTab._t = setTimeout(function () { if (!panes) return; panes.style.scrollSnapType = ''; panes.scrollTo({ left: left, behavior: 'auto' }); }, 520 + Math.min(4, Math.abs(i - cur)) * 160);
    } else {
      panes.scrollTo({ left: left, behavior: 'auto' });
    }
    if (!smooth) { paintIndicator(i); if (i !== cur) setCurrent(i); }
  }
  function ensure(i) { if (i >= 0 && i < TABS.length) { var s = state[i]; if (s && s.page === 0 && !s.loading) loadPage(i); } }

  /* ---------------------------------------------------------------- slide-uri */
  function renderItems(i, items) {
    var s = state[i], pane = s.pane;
    var sk = $('.tprl-skel', pane); if (sk) sk.remove();
    var er = $('.tprl-err', pane); if (er) er.remove();
    var endc = $('.tprl-end', pane); if (endc) endc.remove();
    var first = !$('.tprl-slide[aria-label]', pane);
    favCache = null;
    var near = Math.abs(i - cur) <= 0, CH = near ? 4 : 2, token = (s.token = (s.token || 0) + 1);
    function later(fn) { if (near && window.requestAnimationFrame) requestAnimationFrame(fn); else if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 400 }); else setTimeout(fn, 16); }
    function step(from) {
      if (!state[i] || state[i] !== s) return;                          /* viewerul a fost reconstruit */
      var end = Math.min(items.length, from + CH), k;
      for (k = from; k < end; k++) pane.appendChild(slideEl(items[k], i));
      if (first && from === 0) { var sl = $$('.tprl-slide[aria-label]', pane).slice(0, 2); sl.forEach(function (a) { var im = a._imgs[0]; if (im && !im.src) im.src = im.dataset.src; }); }
      observeSlides(i);
      if (end < items.length) { later(function () { step(end); }); return; }
      if (!s.more && !$('.tprl-end', pane)) pane.appendChild(endSlide(i));
      if (cur === i) refreshActive();
    }
    step(0);
    if (cur === i) refreshActive();
  }
  function renderError(i) {
    var s = state[i], pane = s.pane;
    var sk = $('.tprl-skel', pane); if (sk) sk.remove();
    if ($('.tprl-err', pane)) return;
    var a = el('article', 'tprl-slide tprl-err', '<div class="tprl-endcard"><b>Nu am putut încărca produsele</b><span>Verifică conexiunea și încearcă din nou.</span><button type="button" class="tprl-cta">Reîncearcă</button></div>');
    $('button', a).addEventListener('click', function () { a.remove(); pane.appendChild(skeleton()); s.fails = 0; loadPage(i); });
    pane.appendChild(a);
  }
  function endSlide(i) {
    var next = TABS[i + 1];
    var a = el('article', 'tprl-slide tprl-end',
      '<div class="tprl-endcard"><b>Ai văzut tot din „' + esc(TABS[i].l) + '"</b><span>' + (TABS[i].src === 'local' && !state[i].items.length ? 'Nimic în stoc acum din lista asta.' : 'Mai sunt multe de descoperit.') + '</span>' +
      (next ? '<button type="button" class="tprl-cta" data-next>Următoarea: ' + esc(next.l) + ' ' + ICON.arrow + '</button>' : '') +
      (TABS[i].src === 'local' ? '' : '<a class="tprl-ghost" href="' + esc(TABS[i].href || TABS[i].u) + '">Vezi toată colecția</a>') + '</div>');
    var nb = $('[data-next]', a); if (nb) nb.addEventListener('click', function () { goTab(i + 1, true); });
    return a;
  }

  function slideEl(it, ti) {
    var m = parseItem(it);
    var imgs = it.i && it.i.length ? it.i : [];
    var a = el('article', 'tprl-slide');
    a._it = it; a._m = m; a._ti = ti; a._k = 0;
    a.setAttribute('aria-roledescription', 'produs'); a.setAttribute('aria-label', it.t);
    var photos = imgs.map(function (u, k) { return '<img alt="' + (k === 0 ? esc(it.t) : '') + '" data-src="' + esc(abs(u)) + '" decoding="async" draggable="false">'; }).join('');
    var segs = imgs.length > 1 ? '<div class="tprl-segs" aria-hidden="true">' + imgs.map(function () { return '<i></i>'; }).join('') + '</div>' : '';
    var old = it.c > it.p ? '<s>' + money(it.c) + '</s>' : '';
    a.innerHTML =
      '<div class="tprl-card">' +
        '<div class="tprl-photo">' + segs + photos +
          '<span class="tprl-vendor">' + esc(it.v) + '</span>' +
          '<div class="tprl-rail">' +
            '<button type="button" class="tprl-like" data-h="' + esc(it.h) + '" aria-pressed="false" aria-label="Adaugă la favorite">' + ICON.heart + '</button>' +
            '<button type="button" class="tprl-share" aria-label="Trimite produsul">' + ICON.share + '</button>' +
          '</div>' +
          '<div class="tprl-pop" aria-hidden="true">' + ICON.heart + '</div>' +
          '<div class="tprl-pause" aria-hidden="true">' + ICON.play + '</div>' +
        '</div>' +
        '<div class="tprl-meta"><h3 class="tprl-title">' + esc(it.t) + '</h3><div class="tprl-price"><b>' + money(it.p) + '</b>' + old + '</div></div>' +
      '</div>' +
      '<form class="tprl-buy" action="/cart/add" method="post" novalidate>' +
        '<input type="hidden" name="id" value=""><input type="hidden" name="quantity" value="1">' +
        '<div class="tprl-opts"></div>' +
        '<div class="tprl-actions"><button type="submit" class="tprl-cta"><span class="tprl-cta-t">Adaugă în coș</span></button>' +
        '<a class="tprl-view" href="/products/' + esc(it.h) + '" aria-label="Vezi produsul">' + ICON.arrow + '</a></div>' +
      '</form>';
    a._imgs = $$('.tprl-photo img', a); a._segs = $$('.tprl-segs i', a);
    renderOpts(a);
    paintLike(a);
    bindSlide(a);
    return a;
  }

  function renderOpts(a) {
    var m = a._m, box = $('.tprl-opts', a), h = '';
    if (m.colors.length > 1) {
      h += '<div class="tprl-row tprl-colors" role="radiogroup" aria-label="Culoare">' + m.colors.map(function (c) {
        return '<button type="button" class="tprl-chip tprl-chip--txt' + (c === m.selColor ? ' is-on' : '') + '" role="radio" aria-checked="' + (c === m.selColor) + '" data-c="' + esc(c) + '">' + esc(c) + '</button>';
      }).join('') + '</div>';
    }
    if (m.si >= 0) {
      h += '<div class="tprl-row tprl-sizes" role="radiogroup" aria-label="Mărime">' + m.sizes.map(function (s) {
        var ok = sizeAvail(m, s), on = s === m.selSize;
        return '<button type="button" class="tprl-chip' + (on ? ' is-on' : '') + (ok ? '' : ' is-off') + '" role="radio" aria-checked="' + on + '"' + (ok ? '' : ' aria-disabled="true"') + ' data-s="' + esc(s) + '">' + esc(s) + '</button>';
      }).join('') + '</div>';
    }
    box.innerHTML = h;
    var availSizes = m.si >= 0 ? m.sizes.filter(function (s) { return sizeAvail(m, s); }) : [];
    if (m.selSize != null && availSizes.indexOf(m.selSize) < 0) m.selSize = null;
    if (m.si >= 0 && m.selSize == null && availSizes.length === 1) { m.selSize = availSizes[0]; renderOpts(a); return; }
    syncCta(a);
  }

  function syncCta(a) {
    var m = a._m, v = variantFor(m), btn = $('.tprl-cta', a), t = $('.tprl-cta-t', a), f = $('.tprl-buy', a);
    var needSize = m.si >= 0 && m.selSize == null;
    $('[name=id]', f).value = (!needSize && v && v.a) ? String(v.id) : '';
    btn.classList.toggle('is-need', needSize);
    if (a._done) return;
    t.textContent = needSize ? 'Alege mărimea' : (m.si >= 0 ? 'Adaugă în coș · ' + m.selSize : 'Adaugă în coș');
  }

  function paintLike(a) {
    var on = favHas(a._it.h), b = $('.tprl-like', a);
    b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? 'Scoate de la favorite' : 'Adaugă la favorite');
  }
  function paintAllLikes() { $$('.tprl-slide', dlg).forEach(function (a) { if (a._it) paintLike(a); }); }

  function toast(msg) {
    toastEl.textContent = msg; toastEl.classList.remove('is-on'); void toastEl.offsetWidth; toastEl.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }
  function buzz(ms) { safe(function () { if (navigator.vibrate && matchMedia('(pointer: coarse)').matches) navigator.vibrate(ms); }); }

  function doLike(a, fromDouble) {
    var h = a._it.h, on = favHas(h);
    if (fromDouble && on) { pop(a); return; }          /* dublu-tap pe ceva deja salvat doar pulseaza */
    on = favToggle(h);
    paintAllLikes();
    var b = $('.tprl-like', a);
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
    if (on) { pop(a); buzz(14); }
    toast(on ? 'Salvat la Favorite' : 'Scos de la Favorite');
  }
  function pop(a) {
    var p = $('.tprl-pop', a); p.classList.remove('is-on'); void p.offsetWidth; p.classList.add('is-on');
  }

  function bindSlide(a) {
    var card = $('.tprl-photo', a), buy = $('.tprl-buy', a);
    /* atingere: dublu-tap = favorite; tap simplu = foto anterioara/urmatoare; tinere = pauza */
    var downT = 0, downX = 0, downY = 0, moved = false, lastTap = 0, lastX = 0, tapTimer = 0, holdTimer = 0, held = false;
    card.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button,a') || e.pointerType === 'mouse') return;
      downT = Date.now(); downX = e.clientX; downY = e.clientY; moved = false; held = false;
      holdTimer = setTimeout(function () { held = true; a.classList.add('is-hold'); }, 220);
    });
    function endHold() { clearTimeout(holdTimer); if (a.classList.contains('is-hold')) a.classList.remove('is-hold'); }
    card.addEventListener('pointermove', function (e) { if (!moved && (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8)) { moved = true; clearTimeout(holdTimer); endHold(); } });
    card.addEventListener('pointercancel', function () { moved = true; endHold(); });
    card.addEventListener('pointerup', function (e) {
      if (e.target.closest('button,a')) return;
      var wasHeld = held; endHold();
      if (moved || wasHeld || Date.now() - downT > 400) return;
      var now = Date.now();
      if (now - lastTap < 320) { clearTimeout(tapTimer); lastTap = 0; doLike(a, true); return; }
      lastTap = now; lastX = e.clientX;
      var r = card.getBoundingClientRect(), left = (lastX - r.left) < r.width * .38;
      clearTimeout(tapTimer);
      tapTimer = setTimeout(function () { lastTap = 0; stepPhoto(a, left ? -1 : 1, true); }, 300);
    });
    if (fine) {
      card.addEventListener('mouseenter', function () { a.classList.add('is-hold'); });
      card.addEventListener('mouseleave', function () { a.classList.remove('is-hold'); });
    }
    $('.tprl-like', a).addEventListener('click', function (e) { e.stopPropagation(); doLike(a, false); });
    $('.tprl-share', a).addEventListener('click', function (e) {
      e.stopPropagation();
      var it = a._it, url = location.origin + '/products/' + it.h;
      if (navigator.share) { safe(function () { var p = navigator.share({ title: it.t, text: 'Uite ce pereche am găsit pe TotalPantofi.ro', url: url }); if (p && p.catch) p.catch(function () {}); }); return; }
      safe(function () { navigator.clipboard.writeText(url).then(function () { toast('Link copiat'); }, function () { toast(url); }); });
    });
    $('.tprl-opts', a).addEventListener('click', function (e) {
      var b = e.target.closest('.tprl-chip'); if (!b) return;
      var m = a._m;
      if (b.hasAttribute('data-c')) { m.selColor = b.getAttribute('data-c'); a._done = false; renderOpts(a); return; }
      if (b.classList.contains('is-off')) { shake($('.tprl-sizes', a)); toast('Mărimea nu mai e în stoc'); return; }
      m.selSize = b.getAttribute('data-s'); a._done = false; buzz(8);
      $$('.tprl-sizes .tprl-chip', a).forEach(function (c) { var on = c === b; c.classList.toggle('is-on', on); c.setAttribute('aria-checked', on ? 'true' : 'false'); });
      syncCta(a);
    });
    /* NU ascult 'submit': ascultatorul global din tp-app-ui (faza de captura) il opreste inaintea mea; deci verific la click pe buton */
    $('.tprl-cta', a).addEventListener('click', function (e) {
      var m = a._m, id = $('[name=id]', buy).value, b = e.currentTarget;
      if (b.classList.contains('is-busy')) { e.preventDefault(); return; }
      if (!id) {
        e.preventDefault();
        if (m.si >= 0 && m.selSize == null) { shake($('.tprl-sizes', a)); buzz(20); toast('Alege mărimea'); }
        else toast('Produsul nu mai e disponibil');
        return;
      }
      a._adding = true; a._done = false;
      b.classList.add('is-busy');
      clearTimeout(a._busyT); a._busyT = setTimeout(function () { if (a._adding) { a._adding = false; b.classList.remove('is-busy'); } }, 9000);
    });
    $('.tprl-view', a).addEventListener('click', function () {
      var im = $('.tprl-photo img.is-on', a) || a._imgs[0];
      if (im) im.style.viewTransitionName = 'tpf-hero';
    });
  }
  function shake(node) { if (!node) return; node.classList.remove('is-shake'); void node.offsetWidth; node.classList.add('is-shake'); }

  function onCartUpdated() {
    var a = $('.tprl-slide.is-active', dlg) || null;
    $$('.tprl-slide', dlg).forEach(function (s) {
      if (!s._adding) return;
      s._adding = false; s._done = true;
      var btn = $('.tprl-cta', s); btn.classList.remove('is-busy'); btn.classList.add('is-ok');
      $('.tprl-cta-t', s).innerHTML = ICON.check + ' Adăugat în coș';
      clearTimeout(s._okT); s._okT = setTimeout(function () { s._done = false; btn.classList.remove('is-ok'); syncCta(s); }, 2600);
    });
    return a;
  }

  /* ---------------------------------------------------------------- galerie automata */
  var DUR = 2600;
  function whenReady(im, cb) {
    if (!im) { cb(); return; }
    if (!im.src && im.dataset.src) im.src = im.dataset.src;
    var done = false;
    function fin() { if (done) return; done = true; cb(); }
    function decoded() { if (im.decode) { im.decode().then(fin, fin); } else fin(); }
    if (im.complete && im.naturalWidth) { decoded(); return; }
    im.addEventListener('load', decoded, { once: true }); im.addEventListener('error', fin, { once: true });
    setTimeout(fin, 3000);                       /* nu bloca niciodata galeria daca poza intarzie */
  }
  function showPhoto(a, k) {
    var n = a._imgs.length; if (!n) return;
    k = ((k % n) + n) % n; a._k = k;
    if (a._segs.length) a._segs.forEach(function (s, j) { s.classList.remove('is-run', 'is-done'); if (j < k) s.classList.add('is-done'); });
    var nx = a._imgs[(k + 1) % n]; if (nx && !nx.src && nx.dataset.src) nx.src = nx.dataset.src;
    whenReady(a._imgs[k], function () {
      if (a._k !== k) return;                    /* intre timp s-a cerut alta poza */
      a._imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === k); });
      if (a.classList.contains('is-active')) runPhoto(a);
    });
  }
  function runPhoto(a) {
    if (!a._segs.length) return;
    var s = a._segs[a._k]; if (!s) return;
    s.classList.remove('is-run'); void s.offsetWidth;
    if (!reduce) s.classList.add('is-run');
  }
  function stepPhoto(a, d, manual) {
    if (a._imgs.length < 2) return;
    showPhoto(a, a._k + d);
  }
  function bindSegsEnd(a) {
    if (a._segEnd || !a._segs.length) return; a._segEnd = 1;
    a._segs.forEach(function (s, j) { s.addEventListener('animationend', function (e) { if (e.target !== s && e.animationName !== 'tprl-fill') return; if (j === a._k) stepPhoto(a, 1); }, true); });
  }

  /* ---------------------------------------------------------------- slide activ per panou */
  var observers = [];
  function watchPane(i) {
    if (!('IntersectionObserver' in window)) return;
    var s = state[i];
    observers[i] = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var a = x.target; if (!a._it) return;
        if (x.isIntersecting && x.intersectionRatio >= .6) { s.active = a; if (cur === i) refreshActive(); }
        else if (s.active === a && !x.isIntersecting) { /* iese din ecran */ }
        a._near = x.isIntersecting;
      });
    }, { root: s.pane, threshold: [0, .6] });
  }
  function observeSlides(i) {
    var o = observers[i]; if (!o) return;
    $$('.tprl-slide', state[i].pane).forEach(function (a) { if (a._it && !a._obs) { a._obs = 1; o.observe(a); } });
  }
  function syncInert() {
    state.forEach(function (st, i) {
      var live = (i === cur);
      if (st.pane.inert !== !live) st.pane.inert = !live;
      if (!live) return;
      $$('.tprl-slide', st.pane).forEach(function (a) {
        var inert = !!a._it && a !== st.active;
        if (a.inert !== inert) a.inert = inert;
      });
    });
  }
  function refreshActive() {
    if (!opened) return;
    state.forEach(function (s, i) {
      $$('.tprl-slide.is-active', s.pane).forEach(function (a) { if (i !== cur || a !== s.active || doc.hidden) deactivate(a); });
    });
    var s = state[cur], a = s && s.active;
    syncInert();
    if (!a || doc.hidden || a.classList.contains('is-active')) return;
    activate(a);
  }
  function activate(a) {
    var s = state[a._ti], items = s.items, idx = items.indexOf(a._it);
    a.classList.add('is-active');
    if (srEl) srEl.textContent = a._it.t + ', ' + money(a._it.p);
    bindSegsEnd(a);
    showPhoto(a, a._k || 0);
    /* pre-incarca urmatoarele doua produse */
    var sib = a.nextElementSibling, c = 0;
    while (sib && c < 2) { if (sib._imgs && sib._imgs[0] && !sib._imgs[0].src) sib._imgs[0].src = sib._imgs[0].dataset.src; sib = sib.nextElementSibling; c++; }
    ambient(a._it).then(function (p) { if (a.classList.contains('is-active')) setAmbient(p); });
    if (idx >= items.length - 4) loadPage(a._ti);
    if (idx > 0 || s.pane.scrollTop > 40) hideHint();
    if (tutArm) { tutArm = false; clearTimeout(tutT); tutT = setTimeout(tutStart, 1100); }   /* dupa ce s-a terminat animatia de deschidere */
  }
  function deactivate(a) {
    a.classList.remove('is-active', 'is-hold');
    a._segs.forEach(function (x) { x.classList.remove('is-run'); });
  }
  var ambKey = '';
  function setAmbient(p) {
    var k = p[0].join(',') + '|' + p[1].join(','); if (k === ambKey || !dlg) return; ambKey = k;
    var L = $$('.tprl-bg i', dlg); if (L.length < 2) return;
    var nxt = L[0].classList.contains('is-on') ? L[1] : L[0], prv = nxt === L[0] ? L[1] : L[0];
    nxt.style.setProperty('--tprl-a', rgb(p[0])); nxt.style.setProperty('--tprl-b', rgb(p[1]));
    nxt.classList.add('is-on'); prv.classList.remove('is-on');
  }
  function slidesOf(i) { return $$('.tprl-slide', state[i].pane); }
  function stepSlide(d) {
    var s = state[cur], list = slidesOf(cur), a = s.active, k = list.indexOf(a);
    if (k < 0) k = 0;
    var t = list[Math.max(0, Math.min(list.length - 1, k + d))];
    if (t) s.pane.scrollTo({ top: t.offsetTop, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------------------------------------------------------------- inclinare: mouse pe desktop, giroscop pe telefon (doar slide-ul activ) */
  var tx = 0, ty = 0, tcx = 0, tcy = 0, tiltRaf = 0, tiltEl = null, gyroOn = false, g0 = null, b0 = null;
  function clamp1(v) { return v < -1 ? -1 : v > 1 ? 1 : v; }
  function tiltTick() {
    tiltRaf = 0;
    tcx += (tx - tcx) * .14; tcy += (ty - tcy) * .14;
    var a = dlg && $('.tprl-slide.is-active', dlg), ph = a && $('.tprl-photo', a);
    if (tiltEl && tiltEl !== ph) { tiltEl.style.removeProperty('--tx'); tiltEl.style.removeProperty('--ty'); }
    tiltEl = ph || null;
    if (ph) { ph.style.setProperty('--tx', tcx.toFixed(3)); ph.style.setProperty('--ty', tcy.toFixed(3)); }
    if (Math.abs(tx - tcx) > .003 || Math.abs(ty - tcy) > .003) tiltRaf = requestAnimationFrame(tiltTick);
  }
  function setTilt(nx, ny) { tx = clamp1(nx); ty = clamp1(ny); if (!tiltRaf) tiltRaf = requestAnimationFrame(tiltTick); }
  function onGyro(e) {
    if (e.gamma == null || e.beta == null) return;
    if (g0 == null) { g0 = e.gamma; b0 = e.beta; }
    setTilt((e.gamma - g0) / 18, (e.beta - b0) / 18);
  }
  function tiltOn() {
    if (reduce) return;
    if (fine) {
      dlg.addEventListener('pointermove', onTiltMove, { passive: true });
      dlg.addEventListener('pointerleave', function () { setTilt(0, 0); });
    } else if (window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission !== 'function') {
      g0 = null; b0 = null; gyroOn = true;
      window.addEventListener('deviceorientation', onGyro, { passive: true });
    }
  }
  function tiltOff() {
    if (gyroOn) { window.removeEventListener('deviceorientation', onGyro); gyroOn = false; }
    tx = ty = tcx = tcy = 0;
    if (tiltEl) { tiltEl.style.removeProperty('--tx'); tiltEl.style.removeProperty('--ty'); tiltEl = null; }
  }
  function onTiltMove(e) {
    var a = $('.tprl-slide.is-active .tprl-photo', dlg); if (!a) return;
    var r = a.getBoundingClientRect();
    setTilt((e.clientX - (r.left + r.width / 2)) / (r.width * .75), (e.clientY - (r.top + r.height / 2)) / (r.height * .75));
  }

  /* ---------------------------------------------------------------- tastatura + roata */
  function onKey(e) {
    if (e.target && /^(input|textarea|select)$/i.test(e.target.tagName)) return;
    var k = e.key;
    if (k === 'ArrowDown' || k === 'PageDown') { e.preventDefault(); stepSlide(1); }
    else if (k === 'ArrowUp' || k === 'PageUp') { e.preventDefault(); stepSlide(-1); }
    else if (k === 'ArrowRight') { e.preventDefault(); goTab(cur + 1, true); }
    else if (k === 'ArrowLeft') { e.preventDefault(); goTab(cur - 1, true); }
    else if (k === ' ' && !e.target.closest('button,a')) { e.preventDefault(); var a = state[cur].active; if (a) a.classList.toggle('is-hold'); }
    else if ((k === 'l' || k === 'L') && !e.target.closest('button,a')) { var b = state[cur].active; if (b) doLike(b, false); }
  }
  var wheelLock = 0, wheelIdle = 0;
  function onWheel(e) {
    if (!e.target.closest || !e.target.closest('.tprl-pane')) return;
    if (Math.abs(e.deltaY) < Math.abs(e.deltaX) * 2) return;   /* orizontala sau diagonala: lasa browserul sa schimbe tab-ul */
    e.preventDefault();
    var now = Date.now();
    clearTimeout(wheelIdle); wheelIdle = setTimeout(function () { wheelLock = 0; }, 140);
    if (wheelLock && now - wheelLock < 700) return;
    if (Math.abs(e.deltaY) < 6) return;
    wheelLock = now; stepSlide(e.deltaY > 0 ? 1 : -1);
  }

  function hideHint() { if (hintEl && !hintEl.classList.contains('is-gone')) { hintEl.classList.add('is-gone'); try { localStorage.setItem('tprl_hint', '1'); } catch (e) {} } }

  /* ---------------------------------------------------------------- tutorial la prima intrare: deget care gliseaza + explicatii (o singura data, cheia tprl_tut)
     Nu blocheaza nimic: stratul are pointer-events:none, doar butonul "Am inteles" prinde atingerea. Orice glisare, atingere, rotita sau tasta il inchide. */
  /* pasul "categorie" e un exemplu real: numele categoriei in care esti + vecina ei (urmatoarea, sau precedenta daca esti pe ultima), calculate la pornire */
  var TUT = [];
  function tutSteps(c) {
    var out = [fine ? { k: 'up', t: 'Derulează în jos', s: 'cu rotița mouse-ului sau cu săgeata ↓, ca să vezi următorul model' }
                    : { k: 'up', t: 'Glisează în sus', s: 'ca să vezi următorul model' }];
    if (c) out.push(fine ? { k: 'side', t: 'Schimbă categoria', s: 'Ești în „' + c.cur + '”. Apasă ' + (c.d > 0 ? '→' : '←') + ' ca să ajungi în „' + c.to + '”' }
                         : { k: 'side', t: 'Glisează în lateral', s: 'Ești în „' + c.cur + '”. Glisează ca să ajungi în „' + c.to + '”' });
    out.push(fine ? { k: 'tap', t: 'Dublu click pe poză', s: 'ca s-o salvezi la favorite. Tasta L face la fel' }
                  : { k: 'tap', t: 'Atinge de două ori', s: 'poza, ca s-o salvezi la favorite' });
    return out;
  }
  function tutCtx() {
    var d = TABS[cur + 1] ? 1 : (TABS[cur - 1] ? -1 : 0);
    if (!d || !TABS[cur]) return null;
    return { d: d, cur: TABS[cur].l, to: TABS[cur + d].l };
  }
  function tutImg(i) {
    var s = state[i], it = (i === cur && s && s.active && s.active._it) || (s && s.items && s.items[0]);
    return it && it.i && it.i[0] ? abs(it.i[0]) : '';
  }
  var TUT_MS = 3600, tutEl = null, tutT = 0, tutStep = 0, tutCycles = 0, tutAt = 0, tutTouched = false, tutArm = false, tutMem = false;
  var HAND = '<svg class="tprl-tut__hand" viewBox="0 0 64 82" width="58" height="75" aria-hidden="true"><g fill="#fff"><rect x="15" y="3" width="14" height="48" rx="7"/><rect x="28" y="31" width="12" height="32" rx="6"/><rect x="39" y="34" width="12" height="30" rx="6"/><rect x="50" y="39" width="10" height="26" rx="5"/><path d="M14 42H60V64C60 73.5 52.5 80 43 80H29.5C22 80 17.5 76.5 14 71Z"/><rect x="3" y="47" width="14" height="26" rx="7" transform="rotate(-24 10 60)"/></g><path d="M28.5 40v14M39.5 41v12M50 44v10" stroke="rgba(30,20,30,.16)" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>';
  function tutSeen() { try { if (localStorage.getItem('tprl_tut') === '1') return true; } catch (e) {} return tutMem; }   /* tutMem: doar daca localStorage nu poate fi scris (mod privat), ca sa nu reapara la fiecare deschidere */
  function tutSave() { try { localStorage.setItem('tprl_tut', '1'); } catch (e) { tutMem = true; } hideHint(); }
  function tutChips(c) {   /* categoriile una langa alta, ca in bara de sus; cea curenta marcata "ești aici", vecina tinta "ajungi aici" */
    function chip(i, cls) { var l = TABS[i] && String(TABS[i].l); return l ? '<b class="tprl-tut__chip' + cls + '">' + esc(l.length > 16 ? l.slice(0, 15) + '…' : l) + '</b>' : ''; }
    return '<div class="tprl-tut__tabs">' + chip(cur - 1, c.d < 0 ? ' is-to' : '') + chip(cur, ' is-cur') + chip(cur + 1, c.d > 0 ? ' is-to' : '') + '</div>';
  }
  function tutScene(k, c) {
    var fg = '<span class="tprl-tut__fg"><i class="tprl-tut__dot"></i>' + HAND + '</span>';
    if (k === 'tap') return '<span class="tprl-tut__fg"><i class="tprl-tut__dot"></i><i class="tprl-tut__ring"></i><i class="tprl-tut__ring tprl-tut__ring--2"></i>' + HAND + '</span><span class="tprl-tut__heart">' + ICON.heart + '</span>';
    if (k === 'side' && !fine) return '<div class="tprl-tut__demo" style="--d:' + c.d + '">' + tutChips(c) + '<div class="tprl-tut__cards"><i class="tprl-tut__card tprl-tut__card--a"></i><i class="tprl-tut__card tprl-tut__card--b"></i></div></div>' + fg.replace('<span class="tprl-tut__fg">', '<span class="tprl-tut__fg" style="--d:' + c.d + '">');
    if (k === 'side') return '<div class="tprl-tut__demo" style="--d:' + c.d + '">' + tutChips(c) + '</div><span class="tprl-tut__keys"><b class="tprl-tut__key' + (c.d < 0 ? ' is-go' : ' is-off') + '">' + ICON.arrow.replace('<path ', '<path transform="rotate(180 12 12)" ') + '</b><b class="tprl-tut__key' + (c.d > 0 ? ' is-go' : ' is-off') + '">' + ICON.arrow + '</b></span>';
    if (!fine) return '<i class="tprl-tut__trail"></i>' + fg;
    if (k === 'up') return '<span class="tprl-tut__mouse"><svg viewBox="0 0 48 72" width="54" height="81" aria-hidden="true"><rect x="3" y="3" width="42" height="66" rx="21" fill="rgb(255 255 255 / .14)" stroke="#fff" stroke-width="3"/><rect class="tprl-tut__wheel" x="21" y="14" width="6" height="14" rx="3" fill="#fff"/></svg></span><span class="tprl-tut__down"><i>' + ICON.down + '</i><i>' + ICON.down + '</i><i>' + ICON.down + '</i></span>';
    return '';
  }
  function tutStart() {
    if (!opened || closing || !dlg || tutEl || tutSeen()) return;
    var st = state[cur], shell = $('.tprl-shell', dlg);
    if (!shell || !st) return;
    if (st.pane.scrollTop > 40) { tutSave(); return; }   /* a derulat deja singur: stie */
    var c = tutCtx(); TUT = tutSteps(c);
    var n = el('div', 'tprl-tut' + (fine ? ' is-fine' : ''));
    n.setAttribute('role', 'group'); n.setAttribute('aria-label', 'Cum folosești Descoperă'); n.setAttribute('data-step', '1');
    n.innerHTML =
      '<div class="tprl-tut__txt">' + TUT.map(function (x, i) { return '<div class="tprl-tut__tx" data-n="' + (i + 1) + '"><b>' + esc(x.t) + '</b><span>' + esc(x.s) + '</span></div>'; }).join('') + '</div>' +
      '<div class="tprl-tut__stage" aria-hidden="true">' + TUT.map(function (x, i) { return '<div class="tprl-tut__sc tprl-tut__sc--' + x.k + '" data-n="' + (i + 1) + '">' + tutScene(x.k, c) + '</div>'; }).join('') + '</div>' +
      '<div class="tprl-tut__dots" aria-hidden="true">' + TUT.map(function (x, i) { return '<i data-n="' + (i + 1) + '"></i>'; }).join('') + '</div>' +
      '<button type="button" class="tprl-tut__ok">Am înțeles</button>';
    shell.appendChild(n);
    if (c && !fine) {   /* pozele din categoria curenta si din cea vecina (deja incarcate in viewer), ca exemplu */
      var ca = $('.tprl-tut__card--a', n), cb = $('.tprl-tut__card--b', n), ia = tutImg(cur), ib = tutImg(cur + c.d);
      if (ca && ia) ca.style.backgroundImage = 'url("' + ia + '")';
      if (cb && ib) cb.style.backgroundImage = 'url("' + ib + '")';
    }
    tutEl = n; tutStep = 0; tutCycles = 0; tutTouched = false; tutAt = Date.now();
    $('.tprl-tut__ok', n).addEventListener('click', function () { tutEnd(true); });
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (tutEl === n) n.classList.add('is-on'); }); });
    tutT = setTimeout(tutAdvance, TUT_MS);
  }
  function tutAdvance() {
    if (!tutEl) return;
    tutStep++;
    if (tutStep >= TUT.length) { tutCycles++; if (tutCycles >= 2) { tutEnd(true); return; } tutStep = 0; }
    if (tutStep === 1) tutSave();   /* a vazut gestul principal: nu-l mai aratam la urmatoarea deschidere */
    tutEl.setAttribute('data-step', String(tutStep + 1));
    tutT = setTimeout(tutAdvance, TUT_MS);
  }
  function tutEnd(mark, praise) {
    clearTimeout(tutT);
    var n = tutEl; tutEl = null;
    if (mark) tutSave();
    if (!n) return;
    n.classList.remove('is-on');
    setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 520);
    if (praise && toastEl) toast(praise);
  }
  function tutOnClick(e) { if (tutEl && !(e.target.closest && e.target.closest('.tprl-tut__ok, .tprl-x, .tprl-snd'))) tutEnd(true); }   /* X inchide viewerul: tutorialul nu se considera vazut */
  function tutOnScroll(e) {
    if (!tutEl || !tutTouched || Date.now() - tutAt < 400) return;
    var t = e.target; if (!t || !t.classList || !(t.classList.contains('tprl-pane') || t.classList.contains('tprl-panes'))) return;
    tutEnd(true, 'Așa, ai prins ideea');
  }

  /* ---------------------------------------------------------------- muzica de fundal (lo-fi calm, ORIGINALA)
     Generata din cod cu Web Audio: sinusuri/triunghiuri + zgomot, acorduri si melodie compuse aici. Nu exista samples si nu e nicio piesa existenta
     => nicio problema de drepturi de autor, nu cere atribuire. Porneste cand clientul deschide viewerul (gest), buton difuzor pentru oprire,
     preferinta in localStorage tprl_snd ("0" = oprita). Se opreste la inchidere / cand fila nu e vizibila. */
  var AC = window.AudioContext || window.webkitAudioContext;
  var SND_BPM = 78, SND_VOL = 0.8;
  var SND_CHORDS = [   /* b = bas (midi), c = acord; 8 masuri: C - Am - Dm - G, apoi F - Em - Dm - G */
    { b: 48, c: [52, 55, 59, 62] }, { b: 45, c: [55, 59, 60, 64] }, { b: 50, c: [53, 57, 60, 64] }, { b: 43, c: [53, 59, 62, 64] },
    { b: 41, c: [57, 60, 64, 67] }, { b: 40, c: [55, 59, 62, 67] }, { b: 50, c: [53, 57, 60, 64] }, { b: 43, c: [53, 59, 62, 64] }
  ];
  var SND_SCALE = [72, 74, 76, 79, 81, 84];   /* pentatonica de Do major, suna bine peste toate acordurile */
  var snd = { ctx: null, G: null, timer: 0, t: 0, bar: 0, on: false };
  var sndBtn = null;
  function mf(m) { return 440 * Math.pow(2, (m - 69) / 12); }
  function rnd(a) { return a * (Math.random() * 2 - 1); }
  function sndPref() { try { return localStorage.getItem('tprl_snd') !== '0'; } catch (e) { return true; } }
  function sndGraph(ctx) {
    var G = {}, sr = ctx.sampleRate, i, c, d, len;
    G.master = ctx.createGain(); G.master.gain.value = 0;
    var comp = ctx.createDynamicsCompressor(); comp.threshold.value = -24; comp.knee.value = 24; comp.ratio.value = 3; comp.attack.value = .02; comp.release.value = .25;
    var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 5200; lp.Q.value = .5;
    G.bus = ctx.createGain();
    G.bus.connect(lp); lp.connect(comp); comp.connect(G.master); G.master.connect(ctx.destination);
    /* reverb: raspuns la impuls din zgomot cu decadere */
    len = Math.floor(sr * 2.2);
    var ir = ctx.createBuffer(2, len, sr);
    for (c = 0; c < 2; c++) { d = ir.getChannelData(c); for (i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.6); }
    var conv = ctx.createConvolver(); conv.buffer = ir;
    var wet = ctx.createGain(); wet.gain.value = .3;
    G.rev = ctx.createGain(); G.rev.connect(conv); conv.connect(wet); wet.connect(lp);
    /* ecou punctat pentru melodie */
    var dl = ctx.createDelay(1); dl.delayTime.value = 60 / SND_BPM * .75;
    var dlp = ctx.createBiquadFilter(); dlp.type = 'lowpass'; dlp.frequency.value = 2200;
    var fb = ctx.createGain(); fb.gain.value = .34;
    G.dly = ctx.createGain(); G.dly.connect(dl); dl.connect(dlp); dlp.connect(fb); fb.connect(dl); dlp.connect(lp);
    /* canale: clape + melodie (cu reverb), tobe + bas (uscate) */
    G.keys = ctx.createGain(); G.keys.connect(G.bus); var kr = ctx.createGain(); kr.gain.value = .55; G.keys.connect(kr); kr.connect(G.rev);
    G.mel = ctx.createGain(); G.mel.connect(G.bus); var mr = ctx.createGain(); mr.gain.value = .6; G.mel.connect(mr); mr.connect(G.rev); var md = ctx.createGain(); md.gain.value = .5; G.mel.connect(md); md.connect(G.dly);
    G.dr = ctx.createGain(); G.dr.connect(G.bus);
    /* zgomot alb pentru tobe + "vinil" (pocnituri rare, foarte incet) */
    G.noise = ctx.createBuffer(1, sr * 2, sr); d = G.noise.getChannelData(0); for (i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    var cr = ctx.createBuffer(1, sr * 4, sr); d = cr.getChannelData(0);
    for (i = 0; i < d.length; i++) { d[i] = rnd(.006); if (Math.random() < .0004) { var a = .35 + Math.random() * .5, n = Math.floor(sr * .004); for (var k = 0; k < n && i + k < d.length; k++) d[i + k] += a * (Math.random() * 2 - 1) * (1 - k / n); } }
    var cs = ctx.createBufferSource(); cs.buffer = cr; cs.loop = true;
    var cf = ctx.createBiquadFilter(); cf.type = 'bandpass'; cf.frequency.value = 2400; cf.Q.value = .5;
    var cg = ctx.createGain(); cg.gain.value = .35;
    cs.connect(cf); cf.connect(cg); cg.connect(G.bus); cs.start(0);
    return G;
  }
  function sTone(ctx, t, type, f, g0, atk, dur, dest) {
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = type; o.frequency.setValueAtTime(f, t);
    g.gain.setValueAtTime(.0001, t); g.gain.linearRampToValueAtTime(g0, t + atk); g.gain.exponentialRampToValueAtTime(.0001, t + dur);
    o.connect(g); g.connect(dest); o.start(t); o.stop(t + dur + .05);
  }
  function sKey(ctx, G, t, m, v, dur) {   /* clapa tip pian electric: fundamentala + armonica + un mic "clinc" la atac */
    var f = mf(m) * (1 + rnd(.0015));
    sTone(ctx, t, 'sine', f, v, .006, dur, G.keys);
    sTone(ctx, t, 'triangle', f * 2, v * .26, .005, dur * .42, G.keys);
    sTone(ctx, t, 'sine', f * 3.99, v * .05, .003, .2, G.keys);
  }
  function sHit(ctx, G, t, v, dur, type, freq, q) {
    var s = ctx.createBufferSource(); s.buffer = G.noise;
    var f = ctx.createBiquadFilter(); f.type = type; f.frequency.value = freq; f.Q.value = q || .7;
    var g = ctx.createGain(); g.gain.setValueAtTime(v, t); g.gain.exponentialRampToValueAtTime(.0001, t + dur);
    s.connect(f); f.connect(g); g.connect(G.dr); s.start(t, Math.random() * 1.5); s.stop(t + dur + .05);
  }
  function sKick(ctx, G, t, v) {
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = 'sine'; o.frequency.setValueAtTime(125, t); o.frequency.exponentialRampToValueAtTime(48, t + .13);
    g.gain.setValueAtTime(v, t); g.gain.exponentialRampToValueAtTime(.0001, t + .34);
    o.connect(g); g.connect(G.dr); o.start(t); o.stop(t + .4);
  }
  function sndBar(ctx, G, t0, idx) {   /* o masura = 4 timpi; tempo lenes, swing usor, mici variatii omenesti */
    var beat = 60 / SND_BPM, sw = beat * .09, ch = SND_CHORDS[idx % SND_CHORDS.length], k;
    function at(b) { return t0 + b * beat + ((b * 2) % 2 === 1 ? sw : 0) + rnd(.007); }
    function chord(t, v, dur) { for (k = 0; k < ch.c.length; k++) sKey(ctx, G, t + k * .02 + Math.random() * .008, ch.c[k], v * (.9 + Math.random() * .2), dur); }
    chord(at(0), .085, 2.7);
    chord(idx % 2 ? at(2.5) : at(1.5), .05, 1.3);
    /* bas */
    sTone(ctx, at(0), 'sine', mf(ch.b), .24, .012, 1.0, G.dr); sTone(ctx, at(0), 'sine', mf(ch.b) * 2, .07, .012, .5, G.dr);
    if (Math.random() < .75) { sTone(ctx, at(2.5), 'sine', mf(ch.b), .15, .012, .6, G.dr); sTone(ctx, at(2.5), 'sine', mf(ch.b) * 2, .04, .012, .3, G.dr); }
    /* tobe: bubuitura pe 1 si "si-ul" lui 3, caseta pe 2 si 4, hi-hat pe optimi cu accent pe off-beat */
    sKick(ctx, G, at(0), .46); if (Math.random() < .8) sKick(ctx, G, at(2.5), .3);
    sHit(ctx, G, at(1), .1, .17, 'bandpass', 1800, .9); sHit(ctx, G, at(1), .03, .12, 'highpass', 4200, .7);
    sHit(ctx, G, at(3), .1, .17, 'bandpass', 1800, .9); sHit(ctx, G, at(3), .03, .12, 'highpass', 4200, .7);
    for (k = 0; k < 8; k++) sHit(ctx, G, at(k / 2), (k % 2 ? .026 : .016) * (.8 + Math.random() * .4), .045, 'highpass', 7500, .7);
    /* melodie: 2-3 note pe masura (uneori nicio nota, ca sa respire), pas cu pas in pentatonica */
    if (idx > 0 && Math.random() < .85) {
      var pos = [.5, 1.5, 2, 2.5, 3.5].filter(function () { return Math.random() < .55; }).slice(0, 3), si = Math.floor(Math.random() * SND_SCALE.length);
      pos.forEach(function (b) {
        si = Math.max(0, Math.min(SND_SCALE.length - 1, si + (Math.random() < .5 ? -1 : 1) * (Math.random() < .7 ? 1 : 2)));
        var f = mf(SND_SCALE[si]), t = at(b);
        sTone(ctx, t, 'sine', f, .062, .01, 1.5, G.mel); sTone(ctx, t, 'triangle', f * 2, .016, .008, .5, G.mel);
      });
    }
  }
  function sndTick() {
    var c = snd.ctx; if (!c || c.state === 'closed') return;
    while (snd.t < c.currentTime + 1.4) { sndBar(c, snd.G, snd.t, snd.bar++); snd.t += 4 * 60 / SND_BPM; }
  }
  function sndPaint() {
    if (!sndBtn) return;
    sndBtn.classList.toggle('is-off', !snd.on);
    sndBtn.setAttribute('aria-pressed', snd.on ? 'true' : 'false');
    sndBtn.setAttribute('aria-label', snd.on ? 'Oprește muzica' : 'Pornește muzica');
  }
  function sndStop(now) {
    clearInterval(snd.timer); snd.timer = 0;
    var c = snd.ctx, G = snd.G; snd.on = false; snd.ctx = null; snd.G = null;
    sndPaint();
    if (!c) return;
    try { G.master.gain.cancelScheduledValues(c.currentTime); G.master.gain.setTargetAtTime(0, c.currentTime, now ? .02 : .18); } catch (e) {}
    setTimeout(function () { try { c.close(); } catch (e) {} }, now ? 80 : 1100);
  }
  function sndStart() {   /* de chemat sincron din gestul clientului (click/atingere), altfel browserul nu lasa sunetul */
    if (snd.on || !AC || !sndPref() || window.__tprlNoSnd) return;
    try {
      var c = new AC(); snd.ctx = c; snd.G = sndGraph(c); snd.t = c.currentTime + .15; snd.bar = 0; snd.on = true;
      var p = c.resume && c.resume();
      sndTick(); clearInterval(snd.timer); snd.timer = setInterval(sndTick, 300);
      var now = c.currentTime; snd.G.master.gain.setTargetAtTime(SND_VOL, now, .9);   /* intra incet, nu brusc */
      if (p && p.then) p.then(function () { if (snd.ctx === c && c.state !== 'running') sndStop(true); }, function () { if (snd.ctx === c) sndStop(true); });
      setTimeout(function () { if (snd.ctx === c && c.state !== 'running' && !doc.hidden) sndStop(true); }, 800);   /* browserul a refuzat sunetul (fara gest): resume() ramane in asteptare, nu aratam "porneste" degeaba */
      if (sndBtn && !snd.seen) { snd.seen = 1; var first = true; try { first = localStorage.getItem('tprl_snd_seen') !== '1'; localStorage.setItem('tprl_snd_seen', '1'); } catch (e) {} if (first) { sndBtn.classList.add('is-new'); setTimeout(function () { if (sndBtn) sndBtn.classList.remove('is-new'); }, 4200); } }
    } catch (e) { sndStop(true); }
    sndPaint();
  }
  function sndToggle() {
    if (snd.on) { try { localStorage.setItem('tprl_snd', '0'); } catch (e) {} sndStop(); }
    else { try { localStorage.setItem('tprl_snd', '1'); } catch (e) {} sndStart(); }
  }
  doc.addEventListener('visibilitychange', function () {
    var c = snd.ctx; if (!c) return;
    try { if (doc.hidden) c.suspend(); else if (snd.on) c.resume(); } catch (e) {}
  });
  window.addEventListener('pagehide', function () { sndStop(true); });
  function sndRender(secs, cb) {   /* doar pentru teste: randare offline, fara difuzor */
    var OC = window.OfflineAudioContext || window.webkitOfflineAudioContext, sr = 44100, c = new OC(2, Math.floor(sr * secs), sr), G = sndGraph(c);
    G.master.gain.value = SND_VOL;
    var t = .05, i = 0; while (t < secs - 1) { sndBar(c, G, t, i++); t += 4 * 60 / SND_BPM; }
    return c.startRendering().then(cb);
  }

  /* ---------------------------------------------------------------- deschidere / inchidere */
  function origin(elm) {
    var r = elm && elm.getBoundingClientRect ? elm.getBoundingClientRect() : null;
    if (!r || !r.width || r.bottom < 0 || r.top > innerHeight) return { x: innerWidth / 2, y: innerHeight - 70 };
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  function radiusFrom(o) {
    var dx = Math.max(o.x, innerWidth - o.x), dy = Math.max(o.y, innerHeight - o.y);
    return Math.ceil(Math.sqrt(dx * dx + dy * dy)) + 8;
  }
  var bgEls = [];
  function readBg() {
    bgEls = $$('body > main, body > .shopify-section, body > section.shopify-section').filter(function (e) { return e.id !== 'shopify-section-tp-cart-drawer'; });
    return bgEls.map(function (e) { return e.getBoundingClientRect().height; });
  }
  function hideBg(hs) {
    bgEls.forEach(function (e, k) { e.style.setProperty('contain-intrinsic-height', Math.round(hs[k] * 100) / 100 + 'px'); });
    root.classList.add('tprl-lock');
  }
  function showBg() {
    root.classList.remove('tprl-lock');
    bgEls.forEach(function (e) { e.style.removeProperty('contain-intrinsic-height'); });
    bgEls = [];
  }
  function openViewer(sel, from, custom) {
    if (opened) return;
    var want = (custom ? [custom] : []).concat(personalTabs(), STATIC);
    if (built && tabsKey(want) !== tabsKey(TABS)) teardown();
    TABS = want;
    build();
    var id = custom ? 'c' : (typeof sel === 'number' || /^\d+$/.test(String(sel)) ? 's' + (Number(sel) || 0) : String(sel || 's0')), i = 0;
    for (var q = 0; q < TABS.length; q++) if (TABS[q].id === id) { i = q; break; }
    originEl = from || null; lastFocus = doc.activeElement; scrollY0 = lastY;
    var o = origin(originEl), hs = readBg();          /* singurele citiri de layout, inainte de scrieri */
    opened = true;
    hideBg(hs);
    var hinted = false; try { hinted = localStorage.getItem('tprl_hint') === '1'; } catch (e) {}
    tutArm = !tutSeen();
    hintEl.classList.toggle('is-gone', hinted || tutArm);   /* prima data apare tutorialul, nu micul indiciu */
    dlg.showModal();
    measureTabs();
    cur = -1;
    goTab(i, false);
    ensure(i); ensure(i + 1); ensure(i - 1);
    try { history.pushState({ tprl: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    window.addEventListener('popstate', onPop);
    var R = radiusFrom(o);
    if (!reduce && dlg.animate) {
      dlg.animate({ clipPath: ['circle(0px at ' + o.x + 'px ' + o.y + 'px)', 'circle(' + R + 'px at ' + o.x + 'px ' + o.y + 'px)'] }, { duration: 640, easing: 'cubic-bezier(.22,1,.36,1)' });
      var shell = $('.tprl-shell', dlg);
      shell.animate([{ scale: '.9', translate: '0 24px', opacity: 0 }, { scale: '1', translate: '0 0', opacity: 1 }], { duration: 560, delay: 80, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
    }
    setTimeout(function () { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }, 60);
    clearTimeout(openViewer._h); if (!hinted) openViewer._h = setTimeout(hideHint, 4800);
    tiltOn();
    sndStart();
  }
  function onPop() { if (opened) finishClose(); }
  function closeViewer() {
    if (!opened) return;
    if (pushed) { pushed = false; try { history.back(); return; } catch (e) {} }
    finishClose();
  }
  var closing = false;
  function finishClose() {
    if (!opened || closing) return;
    closing = true;
    tutArm = false; tutEnd(false); sndStop();
    window.removeEventListener('popstate', onPop);
    pushed = false;
    tiltOff();
    state.forEach(function (s) { $$('.tprl-slide.is-active', s.pane).forEach(deactivate); });
    var o = origin(originEl), R = radiusFrom(o);
    function done() {
      opened = false; closing = false;
      try { dlg.close(); } catch (e) {}
      showBg();
      if (Math.abs((window.pageYOffset || 0) - scrollY0) > 2) { window.scrollTo({ top: scrollY0, left: 0, behavior: 'instant' }); lastY = scrollY0; }
      if (lastFocus && lastFocus.focus) safe(function () { lastFocus.focus({ preventScroll: true }); });
    }
    if (!reduce && dlg.animate) {
      var an = dlg.animate({ clipPath: ['circle(' + R + 'px at ' + o.x + 'px ' + o.y + 'px)', 'circle(0px at ' + o.x + 'px ' + o.y + 'px)'] }, { duration: 420, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' });
      an.onfinish = function () { try { an.cancel(); } catch (e) {} done(); }; an.oncancel = done;
    } else done();
  }

  /* ---------------------------------------------------------------- lansatoare */
  doc.addEventListener('click', function (e) {
    var cb = e.target.closest && e.target.closest('[data-tprl-coll]');
    if (cb) {
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      var ct = customTab(cb.getAttribute('data-title'));
      openViewer(ct ? 'c' : staticIndexFor(location.pathname), cb, ct);
      return;
    }
    var r = e.target.closest && e.target.closest('[data-tprl-ring], [data-tprl-open]');
    if (!r) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    openViewer(r.getAttribute('data-id') || Number(r.getAttribute('data-i')) || 0, r);
  });
  doc.addEventListener('pointerover', function (e) { var r = e.target.closest && e.target.closest('[data-tprl-ring]'); if (r) prefetch(Number(r.getAttribute('data-i')) || 0); }, { passive: true });
  doc.addEventListener('touchstart', function (e) { var r = e.target.closest && e.target.closest('[data-tprl-ring]'); if (r) prefetch(Number(r.getAttribute('data-i')) || 0); }, { passive: true });
  /* inelele personale ("Favorite", "Vazute") apar primele in randul de pe prima pagina, doar daca exista ceva salvat */
  function personalRings() {
    var row = $('.tprl-rings__row'); if (!row) return;
    $$('.tprl-ring--me', row).forEach(function (n) { n.remove(); });
    var tabs = personalTabs(), first = row.firstChild, startLeft = row.scrollLeft, atStart = startLeft < 16;
    tabs.forEach(function (t) {
      var a = el('a', 'tprl-ring tprl-ring--me');
      a.setAttribute('data-tprl-ring', ''); a.setAttribute('data-id', t.id); a.href = '/';
      var img = '';
      if (t.id === 'rv') { var r0 = rvRead()[0]; if (r0 && r0.i) img = '<img src="' + esc(r0.i) + '" width="64" height="64" alt="" loading="lazy" decoding="async">'; }
      var inner = img || (t.id === 'fav' ? ICON.heart : '');
      a.setAttribute('aria-label', 'Descoperă: ' + t.l);
      a.innerHTML = '<span class="tprl-ring__disc"><span class="tprl-ring__img' + (t.id === 'fav' ? ' tprl-ring__img--heart' : '') + '">' + inner + '</span></span><span class="tprl-ring__label">' + esc(t.l) + '</span>';
      row.insertBefore(a, first);
    });
    if (atStart && tabs.length) row.scrollTo({ left: startLeft, behavior: 'auto' });   /* snap-ul ar tine randul pe "Noutati" si ar ascunde inelele noi */
  }
  personalRings();
  window.addEventListener('storage', function (e) { if (e.key === FKEY) favCache = null; if (e.key === FKEY || e.key === 'tp_rv_v1') personalRings(); });
  paintRings();
  window.tprlOpen = function (i) { openViewer(i || 0, null); };
  if (typeof window.__tprlExpose === 'function') { try { window.__tprlExpose({ sndRender: sndRender, parseItem: parseItem, variantFor: variantFor, sizeAvail: sizeAvail, fromProductJs: fromProductJs, customTab: customTab }); } catch (e) {} }   /* doar pentru teste */
  window.tprlSnd = function () { return snd.ctx ? { on: snd.on, state: snd.ctx.state, bar: snd.bar, t: snd.ctx.currentTime, gain: snd.G.master.gain.value } : { on: snd.on }; };   /* stare, pentru teste */
  window.tprlTabs = function () { return TABS.map(function (t) { return t.id; }); };
})();
